import type { ServiceRequestConfig } from './config';
import type { MailboxInfo } from 'owa-client-types';
import { logStartGreyError } from 'owa-analytics-start/lib/logStartUsage';
/* eslint-disable-next-line @typescript-eslint/no-restricted-imports  -- (https://aka.ms/OWALintWiki)
 * Deprecating getPhysicalRing.ts
 *	> 'isDogfoodEnv' import from 'owa-metatags' is restricted. This value is resolved in ECS as a filter. Please create a feature flight if possible. */
import { isDogfoodEnv } from 'owa-metatags';

export type MailboxInfoEventName =
    | 'Acct-MakeServiceRequestMailbox'
    | 'Acct-FetchWithRetryV2MailboxInfo'
    | 'Acct-DefaultHeadersMailbox';

/**
 * Logs information about the MailboxInfo provided, and if it has non empty values of for
 * the required MailboxInfo properties and if it is a MailboxInfo from the account source
 * list store.
 *
 * @param config Service configuration used
 * @param eventName Compile-time literals for the event name to log
 * @param mailboxInfo MailboxInfo for which information is to be logged
 */
export default function checkAndLogMailboxInfo(
    config: ServiceRequestConfig,
    eventName: MailboxInfoEventName,
    mailboxInfo?: MailboxInfo
): void {
    // This telemetry is intended to provide verbose logging for all requests which will generate a large number
    // of events, this must not happen outside of the dogfood environment

    // Supporting multiple accounts requires that all of the service configuration requests include MailboxInfo
    // to make sure they are correctly routed.
    if (isDogfoodEnv() && config.isFeatureEnabled?.('acct-mailboxinfo-innerring-telemetry')) {
        const isMailboxInfoProvided =
            !!mailboxInfo?.type && !!mailboxInfo?.userIdentity && !!mailboxInfo?.mailboxSmtpAddress;
        const isFromStore =
            isMailboxInfoProvided && !!mailboxInfo?.sourceId && !!mailboxInfo?.mailboxRank;

        if (!isMailboxInfoProvided || !isFromStore) {
            const customData = {
                provided: isMailboxInfoProvided,
                store: isFromStore,
                type: mailboxInfo?.type,
                userId: typeof mailboxInfo?.userIdentity,
                smtp: typeof mailboxInfo?.mailboxSmtpAddress,
                sourceId: typeof mailboxInfo?.sourceId,
                rank: typeof mailboxInfo?.mailboxRank,
            };
            if (eventName === 'Acct-MakeServiceRequestMailbox') {
                const error = new Error('Acct-MakeServiceRequestMailbox');
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 * undefined
                 *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
                 (https://aka.ms/OWALintWiki)
                                 * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                                 *	> Invalid Outlook telemetry EventName "Acct-MakeServiceRequestMailbox": must contain only letters, numbers, or underscores. */
                logStartGreyError('Acct-MakeServiceRequestMailbox', undefined, error, customData);
            } else if (eventName === 'Acct-FetchWithRetryV2MailboxInfo') {
                const error = new Error('Acct-FetchWithRetryV2MailboxInfo');
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 * undefined
                 *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
                 (https://aka.ms/OWALintWiki)
                                 * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                                 *	> Invalid Outlook telemetry EventName "Acct-FetchWithRetryV2MailboxInfo": must contain only letters, numbers, or underscores. */
                logStartGreyError('Acct-FetchWithRetryV2MailboxInfo', undefined, error, customData);
            } else {
                const error = new Error('Acct-DefaultHeadersMailbox');
                /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param, owa-custom-rules/telemetry-event-name-format -- (https://aka.ms/OWALintWiki)
                 * BASELINE: DO NOT COPY/PASTE!
                 * undefined
                 *	> Argument at index 1 for logStartGreyError must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo
                 (https://aka.ms/OWALintWiki)
                                 * Baseline. DO NOT COPY AND PASTE! Grandfathering existing event names; Devs who touch this file should update Event Names to follow Outlook Telemetry Naming Standards
                                 *	> Invalid Outlook telemetry EventName "Acct-DefaultHeadersMailbox": must contain only letters, numbers, or underscores. */
                logStartGreyError('Acct-DefaultHeadersMailbox', undefined, error, customData);
            }
        }
    }
}
